import axios, { InternalAxiosRequestConfig } from 'axios';
import store from 'store/config';

export function applyLocaleHeader(config: InternalAxiosRequestConfig) {
  const { locale } = store.getState();

  if (locale) {
    config.headers['Accept-Language'] = locale;
  }

  return config;
}

export function init() {
  axios.interceptors.request.use(applyLocaleHeader);
}
